export default "__VITE_ASSET__54ddd113__"